import React from "react";
import Image from "next/image";

function ContactDetails() {
  return (
    <div className="red-border flex flex-col gap-8 sm:flex-row sm:justify-between [@media(min-width:800px)]:flex-row sm:w-[66%] [@media(min-width:800px)]:w-[unset]">
      <div>
        <div className="mb-4">
          <p className="mb-3 text-[17px] font-medium leading-none text-system-disabled sm:mb-4">
            <Image
              width={20}
              height={20}
              src="/landing/chat.svg"
              alt="chat"
              className="mr-2 inline align-bottom"
            />
            <span>Contacts</span>
          </p>
          <dl>
            <dt className="text-base leading-[24px] text-system-titanium">Email:</dt>
            <dd>
              <a
                href="mailto:info@wirelessworld.us"
                className="text-base leading-[24px] text-system-sky"
              >
                info@wirelessworld.us
              </a>
            </dd>
            <dd>
              <a
                href="mailto:sales@wirelessworld.us"
                className="text-base leading-[24px] text-system-sky"
              >
                sales@wirelessworld.us
              </a>
            </dd>
          </dl>
        </div>

        <dl>
          <dt className="text-base leading-[24px] text-system-titanium">Phone:</dt>
          <dd>
            <a href="tel:+1 (818) 285-8209" className="text-base leading-[24px] text-system-sky">
              +1 (818) 285-8209
            </a>
          </dd>
        </dl>
      </div>

      <div>
        <p className="mb-3 text-[17px] font-medium leading-none text-system-disabled sm:mb-4">
          <Image
            width={20}
            height={20}
            src="/landing/location.svg"
            alt="chat"
            className="mr-2 inline h-auto w-auto align-bottom"
          />
          <span>Visit us</span>
        </p>
        <p className="text-base leading-[24px] text-system-titanium">Address:</p>
        <p className="max-w-[176px] text-sm leading-[24px] text-system-crystalWhite sm:text-[15px] md:text-base">
          16141 Leadwell Street, Van Nuys, CA 91046, USA
        </p>
      </div>
    </div>
  );
}

function SocialLink({
  href,
  src,
  alt,
  width = 30,
  height = 30,
}: {
  href: string;
  src: string;
  alt: string;
  width?: number;
  height?: number;
}) {
  return (
    <a href={href} target="_blank" rel="noreferrer">
      <Image
        src={src}
        alt={alt}
        width={width}
        height={height}
        className="h-auto w-auto transition-all delay-75 hover:opacity-70"
      />
    </a>
  );
}

function SocialLinks() {
  return (
    <div className="mt-8 sm:mt-0 [@media(min-width:800px)]:mt-12">
      <p className="mb-3 text-[17px] font-medium leading-none text-system-disabled sm:mb-4">
        <img src="/landing/follow.svg" alt="" className="mr-2 inline align-bottom" />
        <span>Follow us</span>
      </p>

      <div className="flex gap-3">
        <SocialLink
          href="https://linkedin.com/company/wirelessworldusa"
          src="/landing/linkedin.svg"
          alt="linkedin"
        />
        <SocialLink href="https://x.com/wirelessworldus" src="/landing/x.svg" alt="twitter" />
        <SocialLink
          href=" https://instagram.com/wirelessworldus/"
          src="/landing/instagram.svg"
          alt="google"
        />
      </div>
    </div>
  );
}

export { ContactDetails, SocialLinks };
